import { render, staticRenderFns } from "./PerformanceByYear.vue?vue&type=template&id=1ceb8dee&scoped=true&"
import script from "./PerformanceByYear.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PerformanceByYear.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PerformanceByYear.vue?vue&type=style&index=0&id=1ceb8dee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb8dee",
  null
  
)

export default component.exports